import React, {useEffect} from 'react'
import {Box, Button, FormField, Grid, PropertyFilter, PropertyFilterProps} from '@amzn/awsui-components-react'
import {METADATA_I18N_STRINGS} from '../metadata/MetadataSearchProperty'
import {PropertyFilterQuery} from '@amzn/awsui-collection-hooks'

type AdvancedSearchProps = {
    label: String,
    filteringProperties: PropertyFilterProps.FilteringProperty[],
    filteringOptions: PropertyFilterProps.FilteringOption[],
    displayedQuery: PropertyFilterProps.Query,
    searchHandler: (query: PropertyFilterQuery) => void,
    displaySearchButton?: boolean,
    onChangeHandler?: (query: PropertyFilterQuery) => void,
    i18nStrings: PropertyFilterProps.I18nStrings,
}

const AdvancedSearch: React.FC<AdvancedSearchProps> = (
    {
        label,
        filteringProperties,
        filteringOptions,
        displayedQuery,
        searchHandler,
        displaySearchButton = true,
        onChangeHandler = () => {},
        i18nStrings = METADATA_I18N_STRINGS,
    },
) => {
    const [query, setQuery] = React.useState<PropertyFilterProps.Query>({
        tokens: [],
        operation: 'and',
    })

    useEffect(() => {
        setQuery(displayedQuery)
    }, [displayedQuery])

    const propertyFilter = (
        <PropertyFilter
            data-testid="property-filter"
            onChange={({detail}) => {
                setQuery(detail)
                onChangeHandler(detail)
            }}
            query={query}
            i18nStrings={i18nStrings}
            expandToViewport
            filteringProperties={filteringProperties}
            filteringStatusType={filteringProperties.length ? 'finished' : 'loading'}
            filteringOptions={filteringOptions}
        />
    )

    return (
        <Grid gridDefinition={[{colspan: 6}, {colspan: 6}]}>
            <FormField label={label} stretch>
                {propertyFilter}
            </FormField>
            { displaySearchButton && <Box margin={{top: 'xl'}}>
                <Button data-test-id="advancedSearchButton" variant="primary" onClick={
                    () => {
                        searchHandler((query))
                    }
                }>Search</Button>
            </Box> }
        </Grid>
    )
}

export default AdvancedSearch
